import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as CyclingSvg } from './assets/cycling.svg';

const CyclingIcon = React.forwardRef((args, ref) => <SvgIcon component={CyclingSvg} ref={ref} {...args} />);

export default CyclingIcon;
